// Pure window-layout algorithms extracted from windows.svelte.js to keep that
// module under the file-size limit. Each mutates the passed window objects in
// place (same references the store owns); the store handles persistence.

function layoutTargets(windows, targetSpaceId) {
  return windows.filter(
    (w) => w.spaceId === targetSpaceId && !w.minimized && !w.fullscreen && !w.splitSide
  );
}

// cascadeLayout offsets each window by a fixed step from the top-left.
export function cascadeLayout(windows, targetSpaceId, menubarH) {
  let startX = 80;
  let startY = menubarH + 20;
  for (const win of layoutTargets(windows, targetSpaceId)) {
    win.x = startX;
    win.y = startY;
    startX += 30;
    startY += 30;
  }
}

// tileLayout packs windows into a near-square grid filling the viewport.
export function tileLayout(windows, targetSpaceId, menubarH) {
  const spaceWins = layoutTargets(windows, targetSpaceId);
  if (spaceWins.length === 0) return;

  const W = globalThis.innerWidth;
  const H = globalThis.innerHeight - menubarH;
  const cols = Math.ceil(Math.sqrt(spaceWins.length));
  const rows = Math.ceil(spaceWins.length / cols);
  const cellW = Math.floor(W / cols);
  const cellH = Math.floor(H / rows);

  let idx = 0;
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      if (idx >= spaceWins.length) break;
      const win = spaceWins[idx];
      win.x = c * cellW;
      win.y = menubarH + r * cellH;
      win.w = cellW;
      win.h = cellH;
      idx++;
    }
  }
}
